import Metrics from '@ibkr/clientportal.common/src/js/Metrics'

export const upnl = (state) => {
    return state.upnl || {};
}

export const acctPnl = (state) => {
    return (state.marketData && state.marketData['-26']) || {};
}

//returns true if iserver is authenticated
export const authenticated = (state) => {
    return (state.status && state.status.authenticated);
}

export const backendDown = (state) => {
    return state.status?.backendDown;
}

export const connected = (state) => {
    if (!state.status) {
        return false;
    }
    if (state.status.authenticated === undefined || state.status.connected === undefined || state.status.competing === undefined) {
        return undefined;
    }
    return state.status.authenticated === true &&
        state.status.connected == true &&
        state.status.competing === false;
}

export const status = (state) => {
    return state.status || {};
}

export const prompts = (state) => {
    return state.status.prompts || [];
}

export const marketData = (state) => {
    return state.marketData || {};
}

export const accounts = (state) => {
    return (state.accounts || [])
        .filter(id => id.toUpperCase() === 'ALL' || (!state.groups.includes(id) && !state.profiles.includes(id)));
}

export const groups = (state) => {
    return state.groups || [];
}

export const profiles = (state) => {
    return state.profiles || [];
}

export const acctProps = (state) => {
    return state.acctProps || {};
}

export const chartPeriods = (state) => {
    return state.chartPeriods || {};
}

export const aliases = (state) => {
    return state.aliases || {};
}

export const selectedAccount = (state) => {
    return state.selectedAccount;
}

export const selectedAccountAlias = (state) => {
    return (state.aliases && state.aliases[state.selectedAccount]) || state.selectedAccount;
}

export const notifications = (state) => {
    return state.notifications || [];
}

export const orders = (state) => {
    return state.orders || [];
}

export const bulletins = (state) => {
    return state.bulletins || [];
}

export const readBulletins = (state) => {
    return state.readBulletins || [];
}

export const unreadBulletins = (state) => {
    return state.bulletins.filter(b => {
        return state.readBulletins.indexOf(b.id) === -1;
    });
}

export const pendingOrdersNum = (state, getters) => {
    return getters.pendingOrders.length;
}

export const executedOrders = (state) => {
    return (state.orders && state.orders.filter(order => {
        return order.status === 'Filled' || order.status === 'Cancelled' || order.status === 'Inactive'
    })) || [];
}

export const pendingOrders = (state) => {
    return (state.orders && state.orders.filter(order => {
        return order.status !== 'Filled' && order.status !== 'Cancelled' && order.status !== 'Inactive'
    })) || [];
}

/**
 * Provides last 10 filled orders
 */
export const executedByOrderid = (state, getters) => {
    const result = [];
    const addedOrders = {};
    let count = 0;
    for (let i = 0; i < getters.executedOrders.length && count < 10; i++) {
        const currOrder = getters.executedOrders[i];
        const orderIdentifier = currOrder.ticker + '' + currOrder.secType;
        if (currOrder.status !== 'Filled' || addedOrders[orderIdentifier]) {
            continue;
        }
        addedOrders[orderIdentifier] = true;
        const obj = {
            orderID: currOrder.orderId,
            order: currOrder
        };
        result.push(obj);
        count++;
    }
    return result || [];
}

export const showIBotMic = (state) => {
    const res = $build.mode == 'development' ||
        "webkitSpeechRecognition" in window ||
        "SpeechRecognition" in window;
    Metrics.instance().registerDaily({
        'type': 'ibot-show-mic',
        'source': 'Common',
        'value-int': res ? 1 : 0
    });
    return res;
}

export const briefing = (state) => {
    return (state.briefingArticle || {});
}

export const links = (state) => {
    return state.links || {};
}

export const gfisLink = (state) => {
    return state.links && state.links.gfis || '';
}

export const showGFIS = (state) => {
    return (state.allowFeatures && state.allowFeatures.showGFIS) || false;
}

export const isLiteUser = (state) => {
    return state.allowFeatures?.liteUser;
}

export const snapshotRefreshTimeout = (state) => {
    //30 seconds by default in phase 1
    return (state.allowFeatures && state.allowFeatures.snapshotRefreshTimeout) || 30;
}

/**
 * Returns true if user has SUPPORTS_WEB_NEWS capability set to true.
 * This is used to toggle 'Better News'
 */
export const showWebNews = (state) => {
    return (state.allowFeatures && state.allowFeatures.showWebNews);
}

export const iserverInfo = (state) => {
    return state.iserverInfo || {};
}

export const showDebugPnl = (state) => {
    return (state.allowFeatures && state.allowFeatures.debugPnl);
}

export const allowFxConv = (state) => {
    return state.allowFeatures && state.allowFeatures.allowFXConv;
}

export const allowResearch = (state) => {
    return (state.allowFeatures && state.allowFeatures.research) || false;
}

export const allowTypeAhead = (state) => {
    return (state.allowFeatures && state.allowFeatures.allowTypeAhead) || false;
}

export const currencyPairs  = (state) => {
    return state.currencyPairs;
}

export const watchlistMap = (state) => {
    return state.watchlistMap || {};
}

/**
 * Show AlertBar when:
 * 1. status.connected is true
 * 2. User is not authenticated (status.authenticated) or user has a competing session (status.competing)
 */
export const showAlertBar = (state) => {
    return state.status.connected &&
        (!state.status.authenticated || state.status.competing || state.accounts.length === 0);
}

/**
 * brokerage authenticated
 * 1. status.connected is true
 * 2. User is authenticated (status.authenticated) and user does not have a competing session (status.competing)
 * 3. iserver accounts.length > 0
 */
export const brokerageAuthenticated = (state) => {
    return state.status.connected &&
        (state.status.authenticated && !state.status.competing && state.accounts.length > 0);
}

export const loggingIn = (state) => {
    return state.loggingIn;
}

export const ccpSessionId = (state) => {
    return state.loginInfo?.sessionId;
}

export const exploreWatchlists = (state) => {
    return state.exploreWls || [];
}

export const watchlists = (state) => {
    return state.watchlists || [];
}

//-- allowedAssetTypes returns a string of all the allowed assetClasses
export const allowedAssetTypes = (state) => {
    return (state.allowFeatures && state.allowFeatures.allowedAssetTypes) || '';
}

export const allowImpactDashboard = (state) => {
    return (state.allowFeatures && state.allowFeatures.showImpactDashboard) || false;
}

export const allowMTA = (state) => {
    return state.allowFeatures && state.allowFeatures.allowMTA;
}

export const allowFinancialLens = (state) => {
    return (state.allowFeatures && state.allowFeatures.allowFinancialLens) || false;
}

// Show corrected trades - CLNTPORTAL-6421
export const correctedTrades = (state) => {
    const trades = [];
    const alreadyProcessedIds = new Set(); // set used to determine if trade is saved or not
    state.trades?.forEach((a,i) => {
        const currExid = a.execution_id.split('.');
        const currKey = currExid[0] + currExid[1] + currExid[2];
        if (!alreadyProcessedIds.has(currKey)) {
            /* if trade is not saved, then save it to trades
             * and add key(first 3 digits of execution_id) to the set
             */
            trades.push(a);
            alreadyProcessedIds.add(currKey);
        } else {
            /*
             * if trade is already saved (present in  the set), then we check if the current
             * trade is a correction of already saved trade, if correction then we replace
             * the saved trade with the current trade
             */
            for (const [idx,e] of trades.entries()) {
                const savedExid = e.execution_id.split('.');
                if ((savedExid[0] + savedExid[1] + savedExid[2]) === currKey) {
                    if (parseInt(currExid[3]) > parseInt(savedExid[3])) {
                        /* if 4th digit of current trade execution_id is greater than the 4th digit
                         * of saved trade execution_id, it's a correction, so replace
                         */
                        trades[idx] = a;
                    }
                    break;
                }
            }
        }
    });
    return trades.sort((t1, t2) => t2.trade_time_r - t1.trade_time_r)
}
